export enum RepliersListingStatus {
  'Active' = 'A',
  'Inactive' = 'U',
}
